const service = {};

service.parseErrors = (errors, configData) => {
  const customErrors = [];
  Object.keys(errors).forEach((key) => {
    let orderlineId = '';
    let productId = '';
    orderlineId = key.slice(key.indexOf('[') + 1, key.indexOf(']'));
    if (configData) {
      productId = JSON.parse(configData).orderLines[orderlineId]
        .dealVoucherProductId;
    }
    const customError = {
      message: errors[key],
      productId,
    };
    customErrors.push(customError);
  });

  return customErrors;
};

export default service;
